import { render, staticRenderFns } from "./QuestionsForm.vue?vue&type=template&id=568721dc&scoped=true"
import script from "./QuestionsForm.vue?vue&type=script&lang=js"
export * from "./QuestionsForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionsForm.vue?vue&type=style&index=0&id=568721dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568721dc",
  null
  
)

export default component.exports